var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 12"}},[_c('path',{attrs:{"d":"M2 6h40","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round"}})])}
var staticRenderFns = []

export default { render: render }